// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForwardOutlinedSvg from "@ant-design/icons-svg/es/asn/ForwardOutlined";
import AntdIcon from '../components/AntdIcon';

var ForwardOutlined = function ForwardOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ForwardOutlinedSvg
  }));
};

ForwardOutlined.displayName = 'ForwardOutlined';
export default React.forwardRef(ForwardOutlined);